import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { LayoutStore } from '../../../store/layout.store';
import { AppsGridComponent } from '../header/apps-grid/apps-grid.component';

@Component({
  selector: 'app-apps-panel',
  imports: [
    AppsGridComponent
  ],
  templateUrl: './apps-panel.component.html',
  styleUrls: ['./apps-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppsPanelComponent {
  private layoutStore = inject(LayoutStore);

  public closePanel = output<void>();

  public isOpen = this.layoutStore.isAppsPanelOpen;

  public onBackdropClick(): void {
    this.closePanel.emit();
  }

  public onPanelClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
